document.addEventListener('DOMContentLoaded', function () {
    // Elemente für das erste Script
    const plusCard = document.querySelector('.nav-item_plus-card');
    const plusItem = document.querySelector('.nav-item_plus'); // Neues Element
    const tabHead = document.querySelector('.preview-settings_tab-head');
    const overlay = document.querySelector('.preview-settings_overlay');
    const tabClose = document.querySelector('.tab_close');
    const closeGallery = document.querySelector('.close_gallery');
    const tabMobileHeader = document.querySelector('.tab_mobile-header');

    // Elemente für das zweite Script
    const tabs = document.querySelectorAll('input[name="tabs"]');
    const previewNav = document.querySelector('.preview-settings_nav');
    const closeButtons = document.querySelectorAll('[close-data-content]');

    // Elemente für das dritte Script
    const allTabModules = document.querySelectorAll('.preview-settings_tab');
    const galleryPreview = document.querySelector('.gallery-preview');
    const previewSettings = document.querySelector('.preview-settings');
    const subnavContents = document.querySelectorAll('.preview-settings_subnav-content');
    const subnavs = document.querySelectorAll('.preview-settings_subnav');
    const dropdownOverlays = document.querySelectorAll('.dropdown_overlay');

    // Funktion zum Synchronisieren der Klasse "visible" zwischen mehreren Elementen
    function syncVisibleClass() {
        const isVisible = tabHead?.classList.contains('visible') && overlay?.classList.contains('visible');
        if (isVisible) {
            plusItem?.classList.add('visible');
        } else {
            plusItem?.classList.remove('visible');
        }
    }

    // Event Listener, um die Klasse "visible" bei tabHead und overlay zu synchronisieren
    [tabHead, overlay].forEach(element => {
        if (element) {
            const observer = new MutationObserver(syncVisibleClass);
            observer.observe(element, { attributes: true, attributeFilter: ['class'] });
        }
    });

    // Event Listener, um tabHead zu schließen, wenn auf plusCard geklickt wird
    if (plusCard) {
        plusCard.addEventListener('click', function () {
            const isVisible = tabHead?.classList.contains('visible');
            if (isVisible) {
                tabHead?.classList.remove('visible');
                overlay?.classList.remove('visible');
                plusItem?.classList.remove('visible'); // Auch plusItem entfernen
            } else {
                tabHead?.classList.add('visible');
                overlay?.classList.add('visible');
            }
        });
    }

    // StandardtabClose-Event für Konsistenz
    if (tabClose) {
        tabClose.addEventListener('click', function () {
            tabHead?.classList.remove('visible');
            overlay?.classList.remove('visible');
            plusItem?.classList.remove('visible');
        });
    }

    if (overlay) {
        overlay.addEventListener('click', function () {
            tabHead?.classList.remove('visible');
            overlay?.classList.remove('visible');
            plusItem?.classList.remove('visible');
        });
    }

    // Funktion zum Synchronisieren der Klasse "active" zwischen galleryPreview und body
    function syncBodyClassWithGalleryPreview() {
        if (galleryPreview.classList.contains('active')) {
            document.body.classList.add('active');
        } else {
            document.body.classList.remove('active');
        }
    }

    // Hinzufügen eines MutationObservers für Änderungen an der Klasse "active" von galleryPreview
    if (galleryPreview) {
        const observer = new MutationObserver(() => {
            syncBodyClassWithGalleryPreview();
        });

        observer.observe(galleryPreview, { attributes: true, attributeFilter: ['class'] });
    }

    // Event Listener für andere Aktionen
    if (closeGallery) {
        closeGallery.addEventListener('click', function () {
            if (galleryPreview) galleryPreview.classList.remove('active');
            if (previewSettings) previewSettings.classList.add('p-hidden');
            if (tabMobileHeader) tabMobileHeader.classList.add('active');

            tabs.forEach(tab => {
                tab.checked = false;
            });

            subnavContents.forEach(content => {
                content.classList.remove('active');
            });

            subnavs.forEach(subnav => {
                subnav.classList.add('p-hidden');
            });
        });
    }

    if (tabMobileHeader) {
        tabMobileHeader.addEventListener('click', function () {
            if (galleryPreview) galleryPreview.classList.add('active');
            if (previewSettings) previewSettings.classList.remove('p-hidden');
            if (previewNav) previewNav.classList.remove('p-hidden');
            if (tabHead) tabHead.classList.add('visible');
            if (overlay) overlay.classList.add('visible');
            tabMobileHeader.classList.remove('active');
        });
    }

    // Funktionen aus dem zweiten Script
    function updateHiddenClass() {
        const isChecked = Array.from(tabs).some(tab => tab.checked);
        if (isChecked) {
            previewNav.classList.add('p-hidden');
        } else {
            previewNav.classList.remove('p-hidden');
        }

        if (tabHead) tabHead.classList.remove('visible');
        if (overlay) overlay.classList.remove('visible');
    }

    tabs.forEach(tab => {
        tab.addEventListener('change', updateHiddenClass);
    });

    closeButtons.forEach(button => {
        button.addEventListener('click', function () {
            previewNav.classList.remove('p-hidden');
            tabs.forEach(tab => {
                tab.checked = false;
            });

            if (tabHead) tabHead.classList.add('visible');
            if (overlay) overlay.classList.add('visible');

            document.addEventListener('click', function handleOutsideClick(event) {
                if (!button.contains(event.target) && !tabHead.contains(event.target) && !overlay.contains(event.target)) {
                    if (tabHead) tabHead.classList.remove('visible');
                    if (overlay) overlay.classList.remove('visible');
                    document.removeEventListener('click', handleOutsideClick);
                }
            });
        });
    });

    document.querySelectorAll('.preview-settings_tab-trigger').forEach(trigger => {
        trigger.addEventListener('click', () => {
            tabs.forEach(tab => {
                tab.disabled = false;
            });

            subnavs.forEach(subnav => {
                subnav.classList.remove('p-hidden');
            });
        });
    });

    dropdownOverlays.forEach(overlay => {
        overlay.addEventListener('click', function () {
            subnavContents.forEach(content => {
                content.classList.remove('active');
            });

            subnavs.forEach(subnav => {
                subnav.classList.remove('p-hidden');
            });
        });
    });

    updateHiddenClass();

    // Funktionen aus dem dritten Script
    allTabModules.forEach(tabModule => {
        const tabContents = tabModule.querySelectorAll('.preview-settings_tab-content');

        tabContents.forEach(tabContent => {
            const subnavButtons = tabContent.querySelectorAll('.subnav-item_button');
            const subnavContents = tabContent.querySelectorAll('.preview-settings_subnav-content');
            const subnav = tabContent.querySelector('.preview-settings_subnav');

            subnavButtons.forEach(button => {
                button.addEventListener('click', function () {
                    const nav = button.getAttribute('data-nav');

                    subnavButtons.forEach(btn => btn.classList.remove('active'));
                    button.classList.add('active');

                    subnavContents.forEach(content => {
                        content.classList.remove('active');
                    });

                    const targetContent = tabContent.querySelector(`.preview-settings_subnav-content[data-navcontent="${nav}"]`);
                    if (targetContent) {
                        targetContent.classList.add('active');
                    }

                    if (subnav) {
                        subnav.classList.add('p-hidden');
                    }
                });
            });

            const closeSubnavButtons = tabContent.querySelectorAll('[close-data-navcontent]');
            const mwButtons = document.querySelectorAll('.mw-r_button');
            const imageSwatchInputs = document.querySelectorAll('.image-swatch-input');

            function closeSubnavContent() {
                subnavContents.forEach(content => {
                    content.classList.remove('active');
                });

                if (subnav) {
                    subnav.classList.remove('p-hidden');
                }
            }

            closeSubnavButtons.forEach(button => {
                button.addEventListener('click', closeSubnavContent);
            });

            mwButtons.forEach(button => {
                button.addEventListener('click', closeSubnavContent);
            });

            imageSwatchInputs.forEach(input => {
                input.addEventListener('click', closeSubnavContent);
            });
        });
    });

    // Neue Funktion zum Entfernen der Klasse "active" bei ausgeblendeten Tabs
    function handleTabSwitchWithActiveCleanup() {
        tabs.forEach(tab => {
            const contentId = tab.id.replace('tab', '');
            const targetContent = document.querySelector(`.preview-settings_tab-content[data-content="${contentId}"]`);

            if (tab.checked) {
                if (targetContent) {
                    targetContent.classList.add('active');
                }
            } else {
                if (targetContent) {
                    targetContent.classList.remove('active');
                    const nestedNavContents = targetContent.querySelectorAll('[data-navcontent]');
                    nestedNavContents.forEach(navContent => {
                        navContent.classList.remove('active');
                    });
                }
            }
        });
    }

    tabs.forEach(tab => {
        tab.addEventListener('change', handleTabSwitchWithActiveCleanup);
    });

    document.querySelectorAll('[data-tab]').forEach(tabTrigger => {
        tabTrigger.addEventListener('click', handleTabSwitchWithActiveCleanup);
    });

    handleTabSwitchWithActiveCleanup();
});
